import {useId, useMemo} from "react";
import type {Property} from "csstype";

import {Select} from "@pg-design/select-module";

interface IProps {
    options?: {label: string; value: number | string}[];
    value: number | string;
    minWidth?: Property.MinWidth;
    onSave: (value: number | string) => void;
    onCancel?: () => void;
}

export const TableCellEditableSelect = (props: IProps) => {
    const instanceId = useId();

    const value = useMemo(() => {
        return props.options?.find((option) => option.value === props.value);
    }, []);

    const onBlur = () => {
        props.onCancel?.();
    };

    const onSelectChange = (newValue?: unknown) => {
        if (newValue) {
            props.onSave((newValue as {value: IProps["value"]}).value);
        } else {
            props.onCancel?.();
        }
    };

    return (
        <Select
            autoFocus
            instanceId={instanceId}
            options={props.options}
            value={value}
            onBlur={onBlur}
            onChange={onSelectChange}
            style={{minWidth: props.minWidth || "12rem"}}
        />
    );
};
import {useId, useMemo} from "react";
import type {Property} from "csstype";

import {Select} from "@pg-design/select-module";

interface IProps {
    options?: {label: string; value: number | string}[];
    value: number | string;
    minWidth?: Property.MinWidth;
    onSave: (value: number | string) => void;
    onCancel?: () => void;
}

export const TableCellEditableSelect = (props: IProps) => {
    const instanceId = useId();

    const value = useMemo(() => {
        return props.options?.find((option) => option.value === props.value);
    }, []);

    const onBlur = () => {
        props.onCancel?.();
    };

    const onSelectChange = (newValue?: unknown) => {
        if (newValue) {
            props.onSave((newValue as {value: IProps["value"]}).value);
        } else {
            props.onCancel?.();
        }
    };

    return (
        <Select
            autoFocus
            instanceId={instanceId}
            options={props.options}
            value={value}
            onBlur={onBlur}
            onChange={onSelectChange}
            style={{minWidth: props.minWidth || "12rem"}}
        />
    );
};
